import { render, staticRenderFns } from "./CompetitionTextSummary.vue?vue&type=template&id=62ed5f50"
import script from "./CompetitionTextSummary.vue?vue&type=script&lang=js"
export * from "./CompetitionTextSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports